import { createSlice } from "@reduxjs/toolkit";
import { ApiCallStatus, ApiResourceState, Resource, ResourceList } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { StateResource } from "@myRedux/state/statesSlice";
import { searchAsyncThunk, windowUrlResourceCallAsyncThunk } from "@myRedux/appAsyncThunkUtilities";

export interface SchoolDistrictResource extends Resource {
  name: string,
  shortName: string,
  state: string,
  emailSuffix: string
}

const initialState = {
  status: ApiCallStatus.Idle,
  value: null
} as ApiResourceState<ResourceList<SchoolDistrictResource>>;

export const searchSchoolDistrictsAsync = searchAsyncThunk<StateResource>('schoolDistrict/searchSchoolDistricts', 'school_districts', 'schooldistrict');

export const getSchoolDistrictBasedOnWindowUrlAsync = windowUrlResourceCallAsyncThunk<SchoolDistrictResource>('schoolDistrict/getSchoolDistrict');

export const schoolDistrictSlice = createSlice({
  name: 'schoolDistrictSlice',
  initialState: initialState,
  reducers: {
    clearSchoolDistricts(state) {
      state.status = ApiCallStatus.Idle;
      state.value = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchSchoolDistrictsAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(searchSchoolDistrictsAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = action.payload;
      })
      .addCase(searchSchoolDistrictsAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      })
      .addCase(getSchoolDistrictBasedOnWindowUrlAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(getSchoolDistrictBasedOnWindowUrlAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = {
          resources: [action.payload],
          links: []
        } 
      })
      .addCase(getSchoolDistrictBasedOnWindowUrlAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      });
  },
});

export const selectSchoolDistricts = (state: RootState) => state.schoolDistrict.schoolDistricts;

const { actions, reducer } = schoolDistrictSlice;
export const { clearSchoolDistricts } = actions;
export default reducer;